<template>
  <div class="text-left p-4">
    <span class="font-bold text-2xl">Interner Bereich</span><br />
    <span class="font-bold text-lg mt-10 inline-block">Artikel hinzufügen</span>
    <input
      v-model="name"
      placeholder="Artikelname"
      class="border border-gray-400 rounded px-2 py-1 mb-2 w-full"
    /><br />
    <input
      v-model="amount"
      type="number"
      step="0.1"
      placeholder="Preis ohne €"
      class="border border-gray-400 rounded px-2 py-1 w-1/3 mr-2"
    /><button
      @click="add()"
      class="border-black border-2 bg-green-500 rounded-lg px-3 py-2 text-white font-bold"
    >
      Hinzufügen
    </button>
    <br /><button
      class="border-black border-2 bg-green-500 rounded-lg px-3 py-2 mt-10 text-white font-bold"
      @click="thanks()"
    >
      Einkauf abschließen
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      amount: "",
    };
  },
  methods: {
    thanks() {
      fetch("https://s.rescanner.de/shop", {
        method: "POST",
         headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "complete",
        }),
      });
    },
    add() {
      fetch("https://s.rescanner.de/shop", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "add",
          amount: this.amount,
          name: this.name,
        }),
      });
      this.amount = "";
      this.name = "";
    },
  },
};
</script>